let unloading = false;

window.addEventListener('beforeunload', () => {
  unloading = true;
  setTimeout(() => { unloading = false; }, 10000);
});
window.addEventListener('pagehide', () => { unloading = true; });
window.addEventListener('pageshow', () => { unloading = false; });

export function markPageUnloading() {
  unloading = true;
}

export function isPageUnloading() {
  return unloading;
}
